module.exports = __webpack_public_path__ + "media/Video 10b.1bb25f55.mp4";